import DrawCanvas from "./views/DrawCanvas.svelte";
import Imprint from "./views/Imprint.svelte";

const routes = [
  {
    name: "/",
    component: DrawCanvas,
  },
  {
    name: "imprint",
    component: Imprint,
  },
  {
    name: "imprint",
    component: Imprint,
  },
];

export { routes };
